import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

declare var Razorpay: any;

@Injectable({ providedIn: "root" })
export class RazorpayService {
  constructor(private http: HttpClient) {}
  payWithRazor(
    amount: number,
    user: any,
    onSuccess: (paymentId: string) => void
  ) {
    this.http
      .post<any>("https://us-central1-illusbookdata.cloudfunctions.net/ssr/createOrder", { amount })
      .subscribe((order) => {
        const options = {
          key: "rzp_live_8VW9qej6OQp7MB",
          amount: amount * 100,
          currency: "INR",
          name: "Illusbook",
          description: "Pro Subscription",
          image: "https://illusbook.com/assets/img/illusbook-logo.png",
          order_id: order.id,
          prefill: {
            name: user.name,
            email: user.email,
            contact: user.phone,
          },
          handler: function (response: any) {
            onSuccess(response.razorpay_payment_id);
          },
          modal: {
            ondismiss: () => {
              alert("Payment cancelled");
            },
          },
        };

        const rzp = new Razorpay(options);
        rzp.open();
      });
  }
}
